import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import MobileCallBar from "@/components/site/MobileCallBar";
import FloatingCTA from "@/components/site/FloatingCTA";
import { Toaster } from "@/components/ui/sonner";

export default function SubLayout({ children }) {
  return (
    <div className="bg-white pb-16 lg:pb-0 min-h-screen">
      <Nav />
      <main className="pt-[68px]">{children}</main>
      <Footer />
      <MobileCallBar />
      <FloatingCTA />
      <Toaster position="top-center" theme="light" richColors />
    </div>
  );
}
